<template>
	<div
		class="steps__step"
		:class="( is_completed_step ) ? ' steps__step--completed' : ( is_current_step ) ? ' steps__step--active' : null"
	>
		<div class="steps__step-number">
			{{ step.step_number }}
		</div>
		<div class="steps__step-title-wrapper">
			<h2 class="steps__step-title">
				{{ step.title }}
			</h2>
			<template v-if="is_completed_step">
				<ul class="steps__step-summary">
					<li v-if="form_fields.project_name">
						Project Name:
						<span>{{ form_fields.project_name }}</span>
					</li>
					<li v-if="form_fields.pandadoc_fee_proposal">
						Link to PandaDoc Fee Proposal:
						<span>{{ form_fields.pandadoc_fee_proposal }}</span>
					</li>
					<li v-if="form_fields.project_type">
						Project Type:
						<span>{{ label_project_type }}</span>
					</li>
					<li v-if="form_fields.project_location">
						Project Location:
						<span>{{ selected_project_location.title }}</span>
					</li>
					<li v-if="form_fields.project_coordinates">
						Project Coordinates:
						<span>{{ form_fields.project_coordinates }}</span>
					</li>
					<li v-if="form_fields.intended_use">
						Intended Use:
						<span>{{ selected_intended_use.label }}</span>
					</li>
					<li v-if="form_fields.kick_off">
						Kick off date:
						<span>{{ format_date( form_fields.kick_off ) }}</span>
					</li>
					<li v-if="form_fields.completion_date">
						Target completion date:
						<span>{{ format_date( form_fields.completion_date ) }}</span>
					</li>
					<li v-if="form_fields.project_description">
						Project Description:
						<span class="pre-wrap">{{ form_fields.project_description }}</span>
					</li>
				</ul>
			</template>
		</div>
		<button
			v-if="is_completed_step"
			class="button button--smaller"
			type="button"
			@click="setActiveStep( step.step_number )"
		>
			Edit
		</button>
		<template v-else-if="is_current_step">
			<ProjectDetailsFormComponent
				:step-title="step.title"
			/>
		</template>
	</div>
</template>

<script setup>
import { useNewProjectStore } from '../../stores/new-project.js';
import { format_date } from '../../../helpers.js';
import { computed, defineProps, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import ProjectDetailsFormComponent from './ProjectDetailsFormComponent';

const new_project_store = useNewProjectStore();
const {
	setActiveStep,
	getProjectLocations
} = new_project_store;
const {
	form_fields,
	label_project_type,
	selected_project_location,
	selected_intended_use
} = storeToRefs( new_project_store );

const props = defineProps( {
	step: {
		required: true,
		type: Object
	},
	activeStepNumber: {
		required: true,
		type: Number
	}
} );

const is_current_step = computed( () => {
	return props.step.step_number === props.activeStepNumber;
} );

const is_completed_step = computed( () => {
	return props.step.step_number < props.activeStepNumber;
} );

onMounted ( async() => {
	await getProjectLocations();
} );

</script>
